function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoVideoYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.003,
    viewBox: "0 0 20 14.003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.588-3.891a2.506,2.506,0,0,0-1.763-1.763C16.26-6.082,10-6.082,10-6.082s-6.26,0-7.825.412A2.556,2.556,0,0,0,.412-3.891,26.4,26.4,0,0,0,0,.92,26.3,26.3,0,0,0,.412,5.73,2.506,2.506,0,0,0,2.175,7.493C3.756,7.921,10,7.921,10,7.921s6.26,0,7.825-.412a2.506,2.506,0,0,0,1.763-1.763A26.41,26.41,0,0,0,20,.936,25.062,25.062,0,0,0,19.588-3.891ZM8.007,3.918v-6l5.206,3Zm0,0",
    transform: "translate(0 6.082)",
    style: {
      fill: "#999"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoVideoYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_video-youtube.64d2b305a08660b607e387b60a7e930b.svg";